import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CompanyContext } from '../../../../../../../context/CompanyContext';
import { ReorderRuleExportConfigurationContext } from '../../../../../../../context/ReorderRuleExportConfigurationContext';

import { Routing } from '../../../../../../../util/routes.util';
import { BackButton, ButtonVariant, CreateButton } from '../../../../../../components/Button';
import ReorderRuleExportConfigurationForm, {
  DraggableReorderRuleExportFieldIdentifier,
} from '../Common/ReorderRuleExportConfigurationForm';
import { useRequest } from '../../../../../../../requests/common/requestHook';
import { ReorderRuleExportConfigurationRequest } from '../../../../../../../requests/reorderRuleExportConfiguration.request';
import { DraggableItemData } from '../../../../../Common/DraggableItem';
import {
  ReorderRuleExportConfiguration,
  ReorderRuleExportField,
  ReorderRuleExportConfigurationInput,
} from '../../../../../../../types/reorder_rule_export_configuration';

interface CreateReorderRuleExportConfigurationPaneProps {}

export default function CreateReorderRuleExportConfigurationPane({}: CreateReorderRuleExportConfigurationPaneProps) {
  const navigate = useNavigate();
  const { currentCompany } = useContext(CompanyContext);
  const { reorderRuleExportConfigurations, setReorderRuleExportConfigurations } = useContext(
    ReorderRuleExportConfigurationContext,
  );

  const [input, setInput] = useState<ReorderRuleExportConfigurationInput>(
    new ReorderRuleExportConfigurationInput(ReorderRuleExportConfiguration.default(currentCompany.id)),
  );

  const [create, { loading }] = useRequest(ReorderRuleExportConfigurationRequest.create);

  const handleCreate = async (
    configuration: ReorderRuleExportConfigurationInput,
    items: DraggableReorderRuleExportFieldIdentifier[],
  ) => {
    configuration.mapping = DraggableItemData.toMap<ReorderRuleExportField>(items);

    const result = await create({ data: [new ReorderRuleExportConfigurationInput(configuration).forCreate()] });
    if (!result) return;

    const config = result[0];
    reorderRuleExportConfigurations.set(config.id, new ReorderRuleExportConfiguration(config));
    setReorderRuleExportConfigurations(new Map(reorderRuleExportConfigurations));
    navigate(Routing.productMasterData.settings.stockTriggers.settings.report.overview());
  };

  const footer = (
    configuration: ReorderRuleExportConfigurationInput,
    items: DraggableReorderRuleExportFieldIdentifier[],
  ) => {
    return (
      <div className='flex justify-end'>
        <div className='flex items-center gap-2'>
          <BackButton
            disabled={loading}
            variant={ButtonVariant.secondary}
            onClick={() => navigate(Routing.productMasterData.settings.stockTriggers.settings.report.overview())}
          />
          <CreateButton
            loading={loading}
            disabled={!configuration.filename || !configuration.name}
            onClick={() => handleCreate(configuration, items)}
          />
        </div>
      </div>
    );
  };

  return <ReorderRuleExportConfigurationForm input={input} setInput={setInput} footer={footer} />;
}
